// src/components/shells/AuthGateShell.jsx
import React from "react";
import "../../styles/skeletons.css";

export default function AuthGateShell() {
  return (
    <div className="auth-gate-shell" aria-hidden="true">
      <div className="auth-gate-card">
        <div
          className="skeleton-shimmer"
          style={{ height: 22, width: "min(210px, 62%)", marginBottom: 14 }}
        />
        <div
          className="skeleton-shimmer"
          style={{ height: 14, width: "100%", marginBottom: 10 }}
        />
        <div
          className="skeleton-shimmer"
          style={{ height: 14, width: "82%" }}
        />
      </div>
    </div>
  );
}